<div class="flex flex-col items-center justify-center">
    <div class="w-full flex items-center justify-end">
        <button (click)="onDismiss()" class="w-6 h-6 rounded-md bg-gray-100">
            <i class="fas fa-times text-sm text-gray-500"></i>
        </button>
    </div>
    <p class="font-semibold font-display text-gray-700">Edit Status Program</p>
    <form [formGroup]="form" (ngSubmit)="onConfirm()" class="mt-4 w-full font-display">
        <mat-select formControlName="status_id" class="font-display h-11 px-4 bg-gray-100 rounded-md py-3 w-full mt-3 text-sm text-gray-500 focus:outline-none" placeholder="Masukkan status program">
            <mat-option class="font-display capitalize" *ngFor="let status of selectedStatus" [value]="status.id">{{status.label}}</mat-option>
        </mat-select>
        <div class="flex w-full items-center justify-end mt-4">
            <button type="submit" class="px-3 py-2 text-white font-medium font-display text-sm bg-primary rounded-md">Simpan</button>
        </div>
    </form>
</div>